// Drop-in replacement for @clerk/clerk-react's useClerk() hook.
// Exposes the same surface area used in this codebase: openSignIn, openSignUp, signOut.

import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function useClerk() {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return {
        openSignIn: (opts = {}) => {
            const redirect = opts?.redirectUrl || "/Dashboard";
            navigate(`/login?redirect=${encodeURIComponent(redirect)}`);
        },
        openSignUp: (opts = {}) => {
            const redirect = opts?.redirectUrl || "/Dashboard";
            navigate(`/register?redirect=${encodeURIComponent(redirect)}`);
        },
        openUserProfile: () => navigate("/Settings"),
        signOut: async () => {
            await logout();
            navigate("/");
        },
        redirectToSignIn: (opts = {}) => {
            navigate(`/login?redirect=${encodeURIComponent(opts?.redirectUrl || "/Dashboard")}`);
        },
        redirectToSignUp: (opts = {}) => {
            navigate(`/register?redirect=${encodeURIComponent(opts?.redirectUrl || "/Dashboard")}`);
        },
    };
}
